import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import clsx from "clsx";
import { toast } from "react-toastify";

import {
  acceptConversationStart,
  fetchConversationInfoStart,
} from "redux/chats/chats.actions";
import { getNotifMsg } from "utils/message";
import CloseConvModal from "./components/CloseConvModal";
import TransferToMeWrapper from "../TransferToMeWrapper";
import ActionButton from "./components/ActionButton";
import styles from "./styles.module.scss";

const CONV_MODAL_INITIAL_STATE = {
  show: false,
  status: null,
};

const getContainer = ({ userData }) => userData.container.data;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;
const getLocale = ({ settingsData }) => settingsData.locale;

// 40 seconds waiting time for refetching button to get enabled again
const REFETCH_WAITING_TIME = 40000;

function AcceptRejectConv() {
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [waitingToFetchConvs, setWaitingToFetchConvs] = useState([]);
  const dispatch = useDispatch();

  const [closeConvModalInfo, setCloseConvModalInfo] = useState(
    CONV_MODAL_INITIAL_STATE
  );

  const container = useSelector(getContainer);
  const selectedConversation = useSelector(getSelectedConversation);
  const locale = useSelector(getLocale);

  const convsChargeCount = +container?.account?.conversationCharge;
  const packageType = container?.package?.type;
  const convType = selectedConversation?.conversation?.convType;

  /* if user have had an accepepted conversation before and their
  account is not expired and just their remaining conersation count is zero then
  they can continue their conversation */
  const hasAgentConv = selectedConversation?.conversation?.chats?.some(
    (item) => item.me
  );
  const isAcceptButtonDisabled =
    packageType === "expire" || (convsChargeCount === 0 && !hasAgentConv);

  const handleAcceptConversation = () => {
    if (packageType === "expire") {
      toast.error(getNotifMsg("BLOCK_ACCEPT_CONV_FOR_EXPIRE_PACKAGE", locale));
      return;
    }
    if (convsChargeCount === 0 && isAcceptButtonDisabled) {
      toast.error(
        getNotifMsg("BLOCK_ACCEPT_CONV_FOR_NOT_ENOUGH_CHARGE", locale)
      );
      return;
    }

    dispatch(
      acceptConversationStart({
        convId: selectedConversation.conversation.id,
        userId: selectedConversation?.user?.id,
      })
    );
  };

  const conversationId = selectedConversation.conversation.id;
  const userId = selectedConversation.user?.id;
  const isUpdatePending = waitingToFetchConvs.includes(conversationId);
  const disabledUpdateConvsBtn = loadingFetch || isUpdatePending;

  const handleCloseConversation = (status) => {
    setCloseConvModalInfo({
      show: true,
      status: status,
    });
  };

  const handleCloseOngoingConvClick = (e) => {
    e.stopPropagation();
    handleCloseConversation("close");
  };

  const handleClosePendingConvClick = (e) => {
    e.stopPropagation();
    handleCloseConversation("denieded");
  };

  const removeConvIdFromWaitingList = (convId) => {
    const newWaitingConvs = waitingToFetchConvs.filter(
      (item) => item !== convId
    );
    setWaitingToFetchConvs(newWaitingConvs);
  };

  // User should wait amount of time until being able to refetch conversation update again. when user clicks button the conversationId will be added to the list
  const addConvIdToWaitingQueue = () => {
    setWaitingToFetchConvs((prev) => [...prev, conversationId]);

    setTimeout(() => {
      removeConvIdFromWaitingList(conversationId);
    }, REFETCH_WAITING_TIME);
  };

  // update conversation to fetch newly exchanged chats
  const handleUpdateConversation = () => {
    // if refetching is in the waiting mode then updating conversation is not allowed
    if (isUpdatePending) return;

    setLoadingFetch(true);

    dispatch(
      fetchConversationInfoStart({
        userId,
        conversationId,
        isPartnerChat: false,
        setLoading: setLoadingFetch,
      })
    );

    addConvIdToWaitingQueue();
  };

  return (
    <div className="flex flex-ai-c flex-columngap-8">
      {closeConvModalInfo.show && (
        <CloseConvModal
          CONV_MODAL_INITIAL_STATE={CONV_MODAL_INITIAL_STATE}
          closeConvModalInfo={closeConvModalInfo}
          setCloseConvModalInfo={setCloseConvModalInfo}
        />
      )}

      {convType === "otherConvs" && (
        <>
          <TransferToMeWrapper>
            <ActionButton
              disabled={isAcceptButtonDisabled}
              type="transferToMe"
            />
          </TransferToMeWrapper>

          <ActionButton
            classNames={{
              icon: clsx([
                loadingFetch && styles.refetch_icon__animated,
                styles.refetch_icon,
              ]),
              button: disabledUpdateConvsBtn && styles.refetch_btn_disabled,
            }}
            handler={handleUpdateConversation}
            type="update"
            text={isUpdatePending && "مکالمه به روز شد"}
          />
        </>
      )}

      {convType === "ongoing" && (
        <ActionButton type="close" handler={handleCloseOngoingConvClick} />
      )}

      {convType === "pending" && (
        <>
          <ActionButton
            type="accept"
            handler={handleAcceptConversation}
            disabled={isAcceptButtonDisabled}
          />

          <ActionButton type="reject" handler={handleClosePendingConvClick} />
        </>
      )}
    </div>
  );
}

export default AcceptRejectConv;
